var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicePersonal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 6,
    fill: "#363A4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 26C12.8954 26 11.9775 26.9076 12.2378 27.9811C12.3907 28.6115 12.6166 29.2297 12.9134 29.8268C13.5165 31.0401 14.4004 32.1425 15.5147 33.0711C16.629 33.9997 17.9519 34.7362 19.4078 35.2388C20.8637 35.7413 22.4241 36 24 36C25.5759 36 27.1363 35.7413 28.5922 35.2388C30.0481 34.7362 31.371 33.9997 32.4853 33.0711C33.5996 32.1425 34.4835 31.0401 35.0866 29.8268C35.3834 29.2297 35.6093 28.6115 35.7622 27.9811C36.0225 26.9076 35.1046 26 34 26L24 26L14 26Z",
    fill: "#363A4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicePersonal);
export default __webpack_public_path__ + "static/media/service_personal.924facab20b922de8a8b892de79ea4e1.svg";
export { ForwardRef as ReactComponent };